"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../keyFactory");
function useSuscriptions(firestore, suscriptionData, options, queryOptions) {
    const shorcutsRef = (0, firestore_2.collection)(firestore, `user/${suscriptionData.uid}/subscriptions`);
    const suscriptionQueryRef = (0, firestore_2.query)(shorcutsRef, 
    /** DEjo el ??true porque sino falla la query, aún si no usamos esta referencia
         * where no se le puede pasar undefined.
         */
    (0, firestore_2.where)("active", "==", suscriptionData.active ?? true));
    return (0, firestore_1.useFirestoreQuery)(keyFactory_1.FirestoreKeys.Suscription({
        name: "suscription",
        path: `user/${suscriptionData.uid}/subscriptions`
    }, [suscriptionData.uid, suscriptionData.active ? "true" : "false"]), 
    /** Si no pidieron las activas, uso la query de la colección */
    suscriptionData.active != undefined ? suscriptionQueryRef : shorcutsRef, options, {
        ...queryOptions,
        select: (suscriptions) => {
            if (suscriptions.empty) {
                return null;
            }
            else {
                const documents = [];
                suscriptions.forEach(sub => {
                    documents.push({
                        ...sub.data(),
                        id: sub.id
                    });
                });
                return documents;
            }
        }
    });
}
exports.default = useSuscriptions;
